// extracted by mini-css-extract-plugin
module.exports = {"list":"style_list__EUodT","item":"style_item__1caUK","itemTitle":"style_itemTitle__14MGX","itemMessage":"style_itemMessage__2txo7"};